// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// used when both grabbing and setting
// a nested value
// this supports standard notation for
// accessing values in javascript, eg.
// foo.bar[0][buzz].fizz
// but because of redux-form
// this also supports a slightly
// invalid javascript value like
// foo[0]bar

// eg.
// "foo.bar[0][fizz].buzz"
// {
//   "foo": {
//     "bar": [{
//       fizz: {
//         buzz: true,
//       }
//     }]
//   }
// }
// would return true

const prepareNestedString = s => {
  // removes any leading or trailing periods or brackets
  s = s.replace(/(^\.|^\[|^]|\.$|\[$|]$)/g, '')

  // captures
  // ].[
  // ][
  // ].
  // ]
  // and replaces with a period
  s = s.replace(/(]\.\[|]\[|]\.|\[|])/g, '.')

  // then splits the string into an array
  return s.split('.')
}

export default prepareNestedString
